<template>
  <div :data-testid="getTestId('admin-image-alignment-page')" style="height: 100%;width: 100%;">
    <ImageAlignmentPage :data-testid="getTestId('admin-image-alignment-page')" />
  </div>
</template>

<script>
import Vue from 'vue';
import { getTestId } from '@/utils/testUtils';

const ImageAlignment = Vue.extend({
  name: 'ImageAlignment',
  components: {
    ImageAlignmentPage: () => import('../../components/image/ImageAlignmentPage.vue')
  },
  methods: {
    /**
     * 테스트 ID 생성
     * @param {string} testId - 테스트 ID
     * @returns {string} 생성된 테스트 ID
     */
    getTestId(testId) {
      return getTestId(testId);
    }
  }
});

export default ImageAlignment;
</script>

<style scoped>
/* 필요한 스타일이 있다면 여기에 추가 */
</style>
